import { render, staticRenderFns } from "./AnalysisDetailsHeader.vue?vue&type=template&id=107b7815&scoped=true&"
import script from "./AnalysisDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./AnalysisDetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisDetailsHeader.vue?vue&type=style&index=0&id=107b7815&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b7815",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
